import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

export default function AutoAnnotationModalContent(): JSX.Element {
  return (
    <div
      id="auto-annotation"
      {...getTestProps({
        component: 'AutoAnnotationModalContent',
        element: 'root',
      })}
    >
      <form>
        <div className="form-group">
          <p>Auto-annotation will add annotations to the current sequence based on matching features.</p>
          <div className="row">
            <div className="col-md-8 feature-library" />
            <div className="col-md-4">
              <button
                type="button"
                className="button button--secondary button--small search-all-libraries-btn"
                {...getTestProps({
                  component: 'AutoAnnotationModalContent',
                  element: 'searchAllLibrariesButton',
                })}
              >
                Search all libraries
              </button>
            </div>
          </div>
        </div>
        <div className="form-group">
          <p>
            Or choose a sequence or sequence folder instead. (Features will be extracted from all annotations
            of 3 or more bases on the selected sequence or sequences in the selected library.)
          </p>
          <div className="sequence-search" />
        </div>
        <div className="annotation-results well well-sm hidden">
          <p className="summary" />
          <table className="table table-hover">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" className="global-visibility-toggle" />
                </th>
                <th>Name</th>
                <th>Location</th>
                <th>Length</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
        <div className="search-throbber hidden" />
      </form>
    </div>
  );
}
